mutation CreateCollectionType($input: CreateCollectionTypeInput!) {
  createCollectionType(input: $input) {
    id
    title
    showInSearch
    collectionDisplayMode
  }
}
